import {
  Columns,
  Column,
  Text,
  Inline,
  ButtonLink,
  TextDropdown,
} from 'braid-design-system';
import queryString from 'query-string';
import React, { useId } from 'react';
import { useSelector } from 'react-redux';

import { getConfigValues } from 'src/config';
import Routes from 'src/config/routes';
import { ListingStatus } from 'src/generated/graphql';
import type { StoreProps } from 'src/store';
import type { DashboardListingFilter } from 'src/types/dashboard';

interface Props {
  showCreateAdButton: boolean;
  activeFilter: DashboardListingFilter;
  onActiveFilterChange: (value: DashboardListingFilter) => void;
}

const TableHeader = ({
  showCreateAdButton,
  activeFilter,
  onActiveFilterChange,
}: Props) => {
  const dropdownId = useId();
  const clientNumber = useSelector(
    (store: StoreProps) => store.account.clientNumber,
  );

  return (
    <Columns space="medium" collapseBelow="tablet">
      <Column width="content">
        {showCreateAdButton && (
          <ButtonLink
            data={{ testid: 'listings-tab-table-header-create-ad-button' }}
            href={queryString.stringifyUrl({
              url:
                getConfigValues().ADVERTISER_CENTRE_URL + Routes.CREATE_AD_URL,
              query: {
                ClientId: clientNumber.toString(),
              },
            })}
            tone="formAccent"
          >
            Create an ad
          </ButtonLink>
        )}
      </Column>

      <Column>
        <Inline space="xsmall" align="right" alignY="center">
          <Text id={dropdownId} component="label">
            Show
          </Text>

          <Text weight="strong">
            <TextDropdown
              id="filter"
              label="Filter ads"
              onChange={(value) => onActiveFilterChange(value)}
              value={activeFilter}
              data={{ testid: 'filterListing' }}
              options={dropdownOptions}
            />
          </Text>
        </Inline>
      </Column>
    </Columns>
  );
};

// These are separated so we can ensure the "value" prop is type safe. When we inline
// in JSX we cannot ensure the "value" prop is a member of "DashboardListingFilter"
const dropdownOptions: Array<{ value: DashboardListingFilter; text: string }> =
  [
    { value: 'all', text: 'All' },
    { value: ListingStatus.Active, text: 'Active' },
    { value: ListingStatus.Draft, text: 'Draft' },
    { value: ListingStatus.Pending, text: 'Pending' },
    { value: ListingStatus.Expired, text: 'Removed' },
  ];

export default TableHeader;
